import {FalloutWidgetProps} from '@pulsoid-private/widgets-lib';
import React from 'react';
import {Col, Form, Row} from 'react-bootstrap';
import Ranges from '../../../system/ranges';
import ColorPicker from './ColorPicker';
import merge from 'lodash/merge';
import {Action} from '../../../system/buttons';
import {PremiumWrapperOverlay} from '../../PremiumWrapperOverlay';

export const FalloutWidgetEdit = (props) => {
  const [configuration, setConfiguration] = React.useState<
    FalloutWidgetProps['configuration']
  >(merge(props.configuration));

  const updateConfiguration = (
    configPart: FalloutWidgetProps['configuration']
  ) => {
    const newConfiguration = {...configuration, ...configPart};
    setConfiguration(newConfiguration);
    props.onUpdate(newConfiguration);
  };

  const handleOnSave = () => {
    props.onSave(configuration);
  };

  return (
    <>
      <PremiumWrapperOverlay
        bi={{
          from: 'widget_edit_premium_update',
          id: props.id,
        }}
        disabled={!props.premiumUpdate}
      >
        <Form.Group>
          <Ranges
            ranges={configuration.ranges}
            defaultRange={{
              from: 40,
              to: 250,
              color: '#14FF1A',
            }}
            onRangesChange={(ranges) => updateConfiguration({ranges})}
            header={
              <Col md={3}>
                <Form inline>
                  <Col>Color</Col>
                </Form>
              </Col>
            }
            rangeConfiguration={(range, onRangeChange) => (
              <Col md={3} key={range.from}>
                <Row>
                  <Col>
                    <Form inline>
                      <ColorPicker
                        color={range.color}
                        onChangeComplete={(color) =>
                          onRangeChange({...range, color})
                        }
                      />
                    </Form>
                  </Col>
                </Row>
              </Col>
            )}
          />
        </Form.Group>
        <Action onClick={handleOnSave}>Save settings</Action>
      </PremiumWrapperOverlay>
    </>
  );
};
